import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "./My_Table.css";
import Select from "react-select";
import { Table, Button, Form } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { editStatusData, postData, putData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import { ApprovalStatus, RoleId, IDS } from "../../../../utils/common";
import AddOffCanvance from "../ExpertOrder";
import search1 from "../../../../Components/assets/icons/search.png";

import ViewOffCanvance from "../ViewOffCanvance";
import Edit from "../ExpertAreaEdit/Edit";
import ExpertAreaCreate from "../ExpertAreaCreate/Create";
import ExpertAreaUpdate from "../ExpertAreaEdit/Edit";

function My_Table({
  data,
  getDataAll,
  OrderByOptions,
  user,
  reset,
  setonPageChange,
  setChangeStatus,
  sortOrder,
  setSortOrder,
  resultsPerPageOptions,
  perPage,
  setperPage,
  setReset,
  hideFilter,
  setHideFilter,
  option,
  setStartDate,
  endDate,
  startDate,
  setEndDate,
  setSearch,
  search,
}) {
  const { IMG_URL, isAllow } = useContext(Context);

  const [show, setShow] = useState(0);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/expert/${id}`);
    setChangeStatus(response);
  };

  const [view, setview] = useState(0);
  const handleViewClose = () => setview(false);

  const handleViewshow = async (id) => {
    await setview(id);
  };

  const [addArea, setAddArea] = useState(0);
  const handleAddAreaClose = () => setAddArea(false);

  const handleAddAreashow = async (id) => {
    await setAddArea(id);
  };

  const [updateArea, setUpdateArea] = useState(0);
  const handleUpdateAreaClose = () => setUpdateArea(false);

  const handleUpdateAreashow = async (id) => {
    await setUpdateArea(id);
  };

  const ChangeApprovedStatus = async (id, status) => {
    const data = {
      approval_status_id: status,
    };
    const response = await putData(`/admin/expert/approved-status/${id}`, data);
    setChangeStatus(response);
  };

  return (
    <section className="pending-table_holder">
      <div className="filters-section">
        <div className="filters-section__label">
          <Button
            className="hide_btn"
            onClick={() => {
              setHideFilter(!hideFilter);
              setSortOrder({
                value: "DESC",
                label: "Sort-by date (Descending)",
              });
              setperPage({ value: 25, label: "Results per page: 25" });
              setReset();
            }}
          >
            {" "}
            {!hideFilter ? "Hide Filter" : "Show Filter"}
          </Button>
          {/* <h6>
            <span>{data?.data?.total} Expert</span>
           
          </h6> */}
        </div>
        {!hideFilter && (
          <div className="filters-section__controls">
            <div className="row mb-3">
              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                <div className="num">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    value={search}
                    placeholder="Search Expert"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setonPageChange(1);
                        getDataAll();
                      }
                    }}
                  />
                </div>
              </div>

              {/* <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                <div className="num">
                  <label className="form-label">Email</label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    value={searchEmail}
                    placeholder="Search Email"
                    onChange={(e) => {
                      setsearchEmail(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                <div className="num">
                  <label className="form-label">Contact Number</label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    value={searchNumber}
                    placeholder="Search Email"
                    onChange={(e) => {
                      setsearchNumber(e.target.value);
                    }}
                  />
                </div>
              </div> */}

              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                <div className="num me-2">
                  <label className="form-label">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="from"
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      setonPageChange(1);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setonPageChange(1);
                        getDataAll();
                      }
                    }}
                  />
                </div>
              </div>

              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                <div className="num me-2">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="to"
                    value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                      setonPageChange(1);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setonPageChange(1);
                        getDataAll();
                      }
                    }}
                  />
                </div>
              </div>

              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                <div className="btn_holder">
                  <div className="Search me-2">
                    <Button
                      type="button"
                      onClick={() => {
                        setonPageChange(1);
                        getDataAll();
                      }}
                      className="btn btn-search"
                    >
                      <img src={search1} className="search" alt="" />
                    </Button>
                  </div>
                  <div className="Search-1">
                    <button
                      type="button"
                      onClick={() => {
                        setSearch("");
                        setEndDate("");
                        setStartDate("");

                        setReset(!reset);
                      }}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>

              {/* <div className="col-lg-4 mb-2">
                <Select
                  options={OrderByOptions}
                  // defaultValue={OrderByOptions[0]}
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="col-lg-4 mb-2">
                <Select
                  options={resultsPerPageOptions}
                  // defaultValue={resultsPerPageOptions[0]}
                  value={perPage}
                  onChange={(e) => setperPage(e)}
                  className="filters-section__dropdown"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                />
              </div>
              <div className="col-lg-4 mb-2">
                <Button
                  variant="outline-secondary"
                  className="filters-section__btn active me-1"
                  onClick={() => {
                    setonPageChange(1);
                    getDataAll();
                  }}
                >
                  Set Table Preferences
                </Button>

                <Button
                  variant="outline-secondary"
                  className="filters-section__btn"
                  onClick={() => {
                    setSortOrder({
                      value: "DESC",
                      label: "Sort-by date (Descending)",
                    });
                    setperPage({ value: 25, label: "Results per page: 25" });
                    setonPageChange(1);
                    setReset(!reset);
                  }}
                >
                  Refresh
                </Button>
              </div> */}
            </div>
          </div>
        )}
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Creation Date</th>
              <th>User details</th>
              {/* <th>Address details</th> */}
              <th>Image</th>
              <th>Status</th>
              <th>Action</th>
              <th>Details</th>
              {/* <th>Payment Receive</th> */}
            </tr>
          </thead>
          <tbody>
            {data?.data?.data?.map((item, index) => (
              <tr key={index}>
                <td className="order-date">
                  <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div>
                </td>

                {/* Owner Details */}
                <td className="order-details">
                  <div className="order-info">
                    <span className="text-highlight">{item?.name}</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.email}</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.contact_no}</span>
                  </div>
                  <div className="order-info">
                    <span className="text-highlight">{item?.Gender?.name}</span>
                  </div>
                </td>

                <td>
                  {" "}
                  {item?.image ? (
                    <img
                      src={IMG_URL + item?.image}
                      alt="Design"
                      className="product-image"
                    />
                  ) : (
                    <>No Image Upload</>
                  )}
                </td>

                <td>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={item?.status}
                      disabled={!isAllow.includes(IDS.Expert.Edit)}
                      onChange={() => {
                        ChangeStatus(item?.id);
                      }}
                      id={`flexSwitchCheckDefault${item?.id}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`flexSwitchCheckDefault${item?.id}`}
                    >
                      {item?.status ? "Active" : "Inactive"}
                    </label>
                  </div>
                </td>

                <td>
                  {isAllow.includes(IDS.Expert.Edit) ? (
                    <div className="d-flex align-items-center gap-3">
                      {item?.approval_status_id === ApprovalStatus.Pending && (
                        <div>
                          <select
                            className={
                              item?.approval_status_id ===
                              ApprovalStatus.Approved
                                ? "status-holder shipped"
                                : "status-holder Unshipped"
                            }
                            onChange={(e) =>
                              ChangeApprovedStatus(item?.id, e.target.value)
                            }
                            value={item?.Approval_Status?.id}
                          >
                            <option value={ApprovalStatus.Pending}>
                              Inactive
                            </option>
                            <option value={ApprovalStatus.Approved}>
                              Approved
                            </option>
                            <option value={ApprovalStatus.Rejected}>
                              Rejected
                            </option>
                          </select>
                        </div>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                  {item?.approval_status_id === ApprovalStatus.Approved && (
                    <>
                      {" "}
                      <div className="d-flex gap-2">
                        <Button
                          className="btn-primary"
                          onClick={() => setShow(item?.id)}
                        >
                          View Orders
                        </Button>

                        {item?.Expert_Areas?.length > 0 ? (
                          <Button
                            className="btn-primary"
                            onClick={() => handleUpdateAreashow(item.id)}
                          >
                            Update Area
                          </Button>
                        ) : (
                          <Button
                            className="btn-primary"
                            onClick={() => handleAddAreashow(item.id)}
                          >
                            Add Area
                          </Button>
                        )}
                      </div>
                    </>
                  )}
                </td>
                <td>
                  {isAllow.includes(IDS.Expert.List) ? (
                    <div className="add me-3">
                      {" "}
                      <Link type="button" className="btn btn-add">
                        <div onClick={() => handleViewshow(item.id)}>
                          View Details
                        </div>
                      </Link>
                    </div>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {view ? (
        <ViewOffCanvance
          handleClose={handleViewClose}
          setShow={setview}
          show={view}
          id={view}
        />
      ) : (
        ""
      )}

      {addArea ? (
        <ExpertAreaCreate
          setChangeStatus={setChangeStatus}
          handleClose={handleAddAreaClose}
          setShow={setAddArea}
          show={addArea}
          id={addArea}
        />
      ) : (
        ""
      )}

      {updateArea ? (
        <ExpertAreaUpdate
          setChangeStatus={setChangeStatus}
          handleClose={handleUpdateAreaClose}
          setShow={setUpdateArea}
          show={updateArea}
          id={updateArea}
        />
      ) : (
        ""
      )}

      {show ? (
        <AddOffCanvance show={show} handleClose={() => setShow(0)} />
      ) : (
        ""
      )}
    </section>
  );
}

export default My_Table;
